import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

export default interface Subscription {
  id: string;
  cancelAtPlanEnd?: boolean;
  customerId: string;
  deviceId: string;
  planEnd?: string;
  planId: string;
  startDate?: string;
  status?: string;
  userEmail?: string;
  userId: number;
  freeTrial?: {
    claimedAt: string;
    endsAt: string;
  };
  plan?: {
    id: string;
    name: string;
    duration: {
      interval: string;
      length: string;
    };
    description?: string;
    price: number;
    metadata?: {
      buyable?: boolean;
      discounts?: {
        id: string;
        name: string;
        message: string;
        amount: number;
        percentage: number;
      }[];
      id?: string;
      paymentMethodRequired?: boolean;
      policy?: string;
      rank?: number | string;
    };
  };
}

export const formatSubsForTable = (subs: Subscription[], type: string) => {
  let formatedSubs = [];
  formatedSubs =
    subs &&
    Array.isArray(subs) &&
    subs.map((s, index) => {
      return {
        ...s,
        id: s.id ? s.id : type + index,
        planName: s.plan?.name,
        startDate: dayjs.utc(s.startDate).format("MM/DD/YYYY"),
        planEnd: dayjs.utc(s.planEnd).format("MM/DD/YYYY"),
      };
    });
  return formatedSubs;
};
